<mat-card>
    <mat-card-title>
        <div>
            <span>{{data.name}}</span>
        </div>

        <button mat-icon-button (click)="close()">
            <fa-icon icon="times"></fa-icon>
        </button>
    </mat-card-title>

    <mat-card-content #content class="row-layout">

        <div class="column-group">
            <div class="item-container">
                <span class="item-header">Status</span>
                <div class="status-container">
                    <mat-icon [class]="getIconClass()"></mat-icon>
                    <span>{{data.status}}</span>
                </div>
            </div>
            
            <div class="item-container">
                <span class="item-header">Impacted Percent</span>
                <span>{{data.percent_impacted | percent : '1.0-2'}}</span>
            </div>
        </div>

        <div class="column-group">
            <div class="item-container">
                <span class="item-header">Total Capacity</span>
                <span>{{data.total_capacity | eagleiNumber}} bpd</span>
            </div>
            
            <div class="item-container">
                <span class="item-header">Impacted Capacity</span>
                <span>{{data.offline_capacity | eagleiNumber}} bpd</span>
            </div>
        </div>

    </mat-card-content>
</mat-card>
